import React, { useState } from "react";
import { DropdownOptionsModal } from "./DropdownOptionsModal";
import { ButtonText } from "components/Atoms/Button";

interface DropdownOptionsNewProps {
  defaultOption: string | null;
  options: string[];
  onSave: (newOptions: string[], defaultOption: string | null) => void;
}

export const DropdownOptionsNew = (props: DropdownOptionsNewProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const onClose = () => {
    setIsOpen(false);
  }

  const onSave = (newOptions: string[], defaultOption: string | null) => {
    onClose();
    props.onSave(newOptions, defaultOption);
  }

  return <>
    {props.options.length === 0 ? <div className="main-section-template-fields-padding">
      <ButtonText
        className="no-padding"
        label={RESX.Buttons.Add}
        onClick={() => setIsOpen(true)}
        htmlType="button"
      />
    </div> : <div className="main-section-template-fields-padding">
      {props.options.map((option, index) => (
        <div key={index}>
          <a onClick={() => setIsOpen(true)} style={{ fontWeight: option === props.defaultOption ? 700 : 400 }}>
            {option} {option === props.defaultOption ? `(${RESX.GeneralLabels.resxDefault})` : ""}
          </a>
        </div>
      ))}
    </div>}
    <DropdownOptionsModal
      isOpen={isOpen}
      displayWarning={false}
      onClose={onClose}
      onSave={onSave}
      defaultOption={props.defaultOption}
      options={props.options}
    />
  </>
}

interface DropdownOptionsDetailProps {
  defaultOption: string | null;
  options: string[];
}

export const DropdownOptionsDetail = (props: DropdownOptionsDetailProps) => {
  return <div>
    {props.options.map((option, index) => (
      <div key={index} style={{ fontWeight: option === props.defaultOption ? 700 : 400 }}>
        {option} {option === props.defaultOption ? `(${RESX.GeneralLabels.resxDefault})` : ""}
      </div>
    ))}
  </div>
}

interface DropdownOptionsInPageEditProps extends DropdownOptionsDetailProps {
  onSave: (newOptions: string[], defaultOption: string | null) => void;
  onClose: () => void;
}

export const DropdownOptionsInPageEdit = (props: DropdownOptionsInPageEditProps) => {
  return <>
    <DropdownOptionsDetail defaultOption={props.defaultOption} options={props.options} />
    <DropdownOptionsModal
      isOpen
      displayWarning
      onClose={props.onClose}
      onSave={props.onSave}
      defaultOption={props.defaultOption}
      options={props.options}
    />
  </>
}